module.exports = __webpack_public_path__ + "static/BA-44bc0b0c14406846cfd8f22232cc3bcb.png";